module.exports = __webpack_public_path__ + "static/media/plano_temuco.24ddcb43.png";